import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Row from '../shared/components/Row';
import Card from '../shared/components/Card';
import CardHeader from '../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../i18n/I18nUtils';
import CardBody from '../shared/components/CardBody';
import { connect } from 'react-redux';
import * as attachmentActions from './attachmentActions';
import * as documentRevisionsActions from '../documents/actions/documentRevisionsActions';
import bindActionCreators from 'redux/es/bindActionCreators';
import { FormSubmit } from '../shared/components/FormSubmit';
import { FormDropzone } from '../shared/components/FormDropzone';
import { ReduxFormUtils } from '../shared/utils/ReduxFormUtils';
import { DatetimeParsers } from '../shared/utils/DatetimeParsers';
import { DateFormatter } from '../shared/formatters/DateFormatter';
import AttachmentList from './AttachmentList';
import { ButtonLabel } from '../shared/components/ButtonLabel';
import FormDate from '../shared/components/FormDate';

const FORM = {
    NAME: 'AttachmentForm',
    FIELDS: {
        DOCS: 'docs', // Almacena los ids de los documentos de AttachmentReducer
        DATE_START: 'dateStart', // ISO Format: 1996-10-15T00:05:32.000Z
        DATE_END: 'dateEnd', // ISO Format: 1996-10-15T00:05:32.000Z
        DATE_END_REQUIRED: 'dateEndRequired',
        FILES: 'files',
        SUBMIT: 'submit',
    },
};

class AttachmentFormCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            submitDisabled: true,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.handleSetDocsToForm(prevProps);
    }

    render() {
        const {
            formValues,
            handleSubmit,
            revisionLoading,
            documents,
            attachmentActions,
        } = this.props;

        return (
            <Row clearfix>
                <Card loading={revisionLoading}>
                    <CardHeader title={I18nUtils.tr('TR_FICHEROS_A_ADJUNTAR_A_LOS_DOCUMENTOS').toUpperCase()}/>
                    <CardBody>
                        <AttachmentList
                            documents={documents}
                            onRemoveDocument={attachmentActions.addOrRemoveDocToAttach}
                            style={{ marginBottom: 30 }}
                        />
                        <form onSubmit={handleSubmit(this.onSubmit)}>
                            <Row>
                                <Field
                                    label={`${I18nUtils.tr('TR_FECHA_DOCUMENTO')}:`}
                                    name={FORM.FIELDS.DATE_START}
                                    type={'date'}
                                    col={'col-md-6'}
                                    disabled={false}
                                    component={FormDate}
                                    format={ReduxFormUtils.dateFormatter}
                                    parse={ReduxFormUtils.dateParser}
                                    normalize={ReduxFormUtils.dateNormalizer}
                                />
                                <Field
                                    label={`${I18nUtils.tr('TR_CADUCIDAD')}:`}
                                    name={FORM.FIELDS.DATE_END}
                                    type={'date'}
                                    col={'col-md-6'}
                                    disabled={!formValues.dateEndRequired}
                                    component={FormDate}
                                    format={ReduxFormUtils.dateFormatter}
                                    parse={ReduxFormUtils.dateParser}
                                    normalize={ReduxFormUtils.dateNormalizer}
                                />
                            </Row>
                            <Row>
                                <Field
                                    name={FORM.FIELDS.FILES}
                                    component={FormDropzone}
                                    mimeTypesAccepted={this.handleMimeTypesAccepted()}
                                    onSubmitDisabled={this.handleSubmitDisabled}
                                />
                            </Row>
                            <Row>
                                <ButtonLabel
                                    label={I18nUtils.tr('TR_CANCELAR')}
                                    className={'col-md-4 col-md-offset-4'}
                                    onClick={this.handleCancel}
                                />
                                <Field
                                    label={I18nUtils.tr('TR_SUBIR')}
                                    name={FORM.FIELDS.SUBMIT}
                                    disabled={this.handleIsSubmitDisabled()}
                                    col={'col-md-4'}
                                    component={FormSubmit}
                                />
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }

    onSubmit = (values) => {
        const { attachmentActions, documentRevisionsActions } = this.props;
        const documentRevisionBatchSave = this.parserSubmit(values);
        attachmentActions.setAttachedFiled(values.files);
        documentRevisionsActions.createDocumentRevisionBatch(documentRevisionBatchSave);
    };

    parserSubmit = (values) => {
        const {
            docs,
            files,
            dateStart,
            dateEnd,
        } = values;

        return {
            document_ids: docs.map(docId => Number(docId)),
            start_date: DatetimeParsers.parseInputDateToISODate(dateStart),
            end_date: DatetimeParsers.parseInputDateToISODate(dateEnd),
            files: files.map(file => ( {
                url: file.file,
                contents: undefined,
                file_type_id: file.fileTypeId,
                size: file.size,
                mime_type: file.mimeType,
                uuid: file.uuid,
                file: file.file,
                name: file.name,
            } )),
        };
    };

    handleSubmitDisabled = (submitDisabled) => {
        this.setState({ submitDisabled });
    };

    handleCancel = (event) => {
        event.preventDefault();
        const { backPathname, attachmentActions } = this.props;
        attachmentActions.goBack(backPathname);
        attachmentActions.clearAttachment();
    };

    handleIsSubmitDisabled = () => {
        const { submitDisabled } = this.state;
        const { documents, formValues } = this.props;
        const noDocs = Object.keys(documents).length === 0;
        const noFiles = !formValues.files || formValues.files.length === 0;
        return submitDisabled || noDocs || noFiles;
    };

    handleSetDocsToForm = (prevProps) => {
        const { documents, change } = this.props;
        const prevKeys = Object.keys(prevProps.documents);
        const nextKeys = Object.keys(documents);
        const diffLength = prevKeys.length !== nextKeys.length;
        if ( diffLength ) change(FORM.FIELDS.DOCS, nextKeys);
    };

    handleMimeTypesAccepted = () => {
        const { documents } = this.props;
        const mimeTypes = [];
        const docs = Object.values(documents);
        docs.forEach(doc => mimeTypes.push(...doc.mimeTypes));
        const mimeTypesUniq = [...new Set(mimeTypes)]; // Evita duplicidades mediante un Conjunto
        // obtenemos los tipos comunes a los documentos
        const commons = mimeTypesUniq.filter(mimeType => docs.every(doc => doc.mimeTypes.includes(mimeType)));
        return commons.join(','); // Formato aceptado por el dropzone: string separado por comas
    };

}

const validate = (values) => {
    const {
        // docs,
        dateStart,
        dateEnd,
        dateEndRequired,
        // files,
        // submit,
    } = values;

    const errors = {};

    const noDateStart = !dateStart || dateStart.length === 0;
    const noDateEnd = dateEndRequired && ( !dateEnd || dateEnd.length === 0 );

    if ( noDateStart ) errors.dateStart = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    if ( noDateEnd ) errors.dateEnd = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

    const invalidDateStart = !!dateStart
        && dateStart.length === 8
        && !DateFormatter.isValid(dateStart);

    const invalidDateEnd = dateEndRequired
        && !!dateEnd
        && dateEnd.length === 8
        && !DateFormatter.isValid(dateEnd);

    if ( invalidDateStart ) errors.dateStart = I18nUtils.tr('TR_FECHA_INCORRECTA');
    if ( invalidDateEnd ) errors.dateEnd = I18nUtils.tr('TR_FECHA_INCORRECTA');

    return errors;
};

const mapStateToProps = (state, ownProps) => {

    const docKeys = Object.keys(state.attachment.documents);
    const docValues = Object.values(state.attachment.documents);
    const dateEndRequired = docValues.some(doc => doc.expires);

    const initialValues = {
        files: [],
        docs: docKeys,
        dateStart: '',
        dateEnd: '',
        dateEndRequired,
    };

    return {
        initialValues,
        formValues: ReduxFormUtils.selectFormValues(state, FORM.NAME),
        documents: state.attachment.documents,
        backPathname: state.attachment.backPathname,
        revisionLoading: state.attachment.revisionLoading,
        fileTypes: state.typedocuments.fileTypes,
    };
};

const mapDispatchToProps = dispatch => ( {
    attachmentActions: bindActionCreators(attachmentActions, dispatch),
    documentRevisionsActions: bindActionCreators(documentRevisionsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
        {
            validate,
            form: FORM.NAME,
            enableReinitialize: false,
        },
    )(AttachmentFormCard),
);

AttachmentFormCard.propTypes = {};

AttachmentFormCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentFormCard.jsx